import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import UploadReceipt from './components/UploadReceipt';
import CreateRoute from './components/CreateRoute';
import InvoicePreview from './components/InvoicePreview';
import Customers from './components/Customers';
import SsoLogin from './components/SsoLogin';
import RequireAuth from './components/RequireAuth';
import { consumeReturnPath } from './returnPath';
import './App.css';

function PostAuthRedirect() {
  const path = consumeReturnPath() || '/dashboard';
  return <Navigate to={path} replace />;
}

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const search = new URLSearchParams(window.location.search);
  const hasSsoHandoff = search.has('token') || search.has('code');

  useEffect(() => {
    const token = localStorage.getItem('token');
    setIsAuthenticated(!!token);
    setLoading(false);
  }, []);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route
            path="/sso"
            element={<SsoLogin setIsAuthenticated={setIsAuthenticated} />}
          />
          <Route
            path="/login"
            element={
              isAuthenticated ? (
                <PostAuthRedirect />
              ) : (
                <Login setIsAuthenticated={setIsAuthenticated} />
              )
            }
          />
          <Route
            path="/dashboard"
            element={
              <RequireAuth isAuthenticated={isAuthenticated}>
                <Dashboard setIsAuthenticated={setIsAuthenticated} />
              </RequireAuth>
            }
          />
          <Route
            path="/upload"
            element={
              <RequireAuth isAuthenticated={isAuthenticated}>
                <UploadReceipt />
              </RequireAuth>
            }
          />
          <Route
            path="/create"
            element={
              <RequireAuth isAuthenticated={isAuthenticated}>
                <CreateRoute />
              </RequireAuth>
            }
          />
          <Route
            path="/customers"
            element={
              <RequireAuth isAuthenticated={isAuthenticated}>
                <Customers />
              </RequireAuth>
            }
          />
          <Route
            path="/invoice/:invoiceId"
            element={
              <RequireAuth isAuthenticated={isAuthenticated}>
                <InvoicePreview />
              </RequireAuth>
            }
          />
          <Route
            path="/"
            element={
              hasSsoHandoff ? (
                <SsoLogin setIsAuthenticated={setIsAuthenticated} />
              ) : isAuthenticated ? (
                <PostAuthRedirect />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
